import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Stack, Typography } from '@mui/material';
import get from 'lodash/get';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import thousands from 'thousands';

import * as Actions from '@/redux/actions';
import { LocaleLink } from 'components/link';
import { useDispatch, useLocale, useSelector } from 'hooks';
import { localizeFund } from 'lib/utils';
import { useI18n } from 'locales';
import PortalHeader from '../../components/PortalHeader';

const selector = (state) => ({
  givingInfo: state.givingInfo,
});

function GiveSuccessPage() {
  const { givingInfo } = useSelector(selector, shallowEqual);
  const dispatch = useDispatch();
  const t = useI18n();
  const locale = useLocale();
  const [searchParams] = useSearchParams();
  const givingId = searchParams.get('id');
  const giving = get(givingInfo, 'data', {});

  useEffect(() => {
    if (givingId) {
      dispatch(Actions.readGiving({ payload: { id: givingId } }));
    }
  }, [dispatch, givingId]);

  const isLoading = givingInfo.isFetching;

  if (isLoading && !givingInfo.dataFetched) {
    return (
      <Stack sx={{
        backgroundColor: 'background.default',
        py: 8,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <CircularProgress />
      </Stack>
    );
  }
  return (
    <Stack sx={{
      backgroundColor: 'background.default',
      pb: 8,
    }}>

      <PortalHeader header={t('GIVING')} />

      <Stack gap={2} sx={{ px: 2, py: 3, alignItems: 'center' }}>
        <Typography color='green.500' sx={{ fontSize: 120 }}>
          <FontAwesomeIcon icon={faCircleCheck} />
        </Typography>

        <Typography variant='h4' color='secondary' sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          {t('THANK YOU FOR YOUR SUPPORT!')}
        </Typography>

        <Stack gap={0.5}>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('You have successfully made a {{term}} giving to', { term: t(get(giving, 'type', '')) })} {localizeFund(get(giving, 'fund', {}), locale) || '[Fund Name]'}.
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('Amount')}: HKD {thousands((giving.amount || 0).toFixed(2))}
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('Ref ID')}: <code>{giving.refId}</code>
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('You can view your giving history in the')}
            <LocaleLink to={`/history?locale=${locale}`} style={{ color: '#00B4AA', marginLeft: 4, marginRight: 4 }}>
              {t('history')}
            </LocaleLink>
            {t('section')}.
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default GiveSuccessPage;
